import { getApiErrorMessage, getApiErrorCode } from '../api/apiUtils';
import withErrorLogger from '../hoc/withErrorLogger';
import RequestError from '../RequestError/RequestError';

const ErrorWithLogger = withErrorLogger(RequestError);

function LogAndDisplayError({ error, log_type = 'react_request_error', log_message = 'Fetch API Error' }) {
  const ErrorMessage = getApiErrorMessage(error);
  const ErrorCode = getApiErrorCode(error);

  const errorLog = {
    log_type: log_type,
    log_message: log_message,
    error: ErrorMessage,
  };
  return <ErrorWithLogger errorLog={errorLog} source={ErrorCode} errorMessage={ErrorMessage} displayNextSteps />;
}

export default LogAndDisplayError;
